import { Http } from 'Core/utils'

import { HelpCenter } from 'Portals/Supplier/entities'

import { baseUrl } from './constants'

export const sendRequest = (payload: HelpCenter.Request): Promise<void> =>
	Http.post(`${baseUrl}/request`, payload)
